import React, { Component } from 'react'
import { Container, Table, Button, Spinner } from 'react-bootstrap'
import { withRouter } from 'react-router-dom'
import { AdminNav, Loading } from '../../helpers';
import axios from 'axios'
import { convertRiceTypeENToTH, addCommaInNumber } from '../../helpers/function'
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import '../datepicker.css'
const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

class CertificateTable extends Component {
  constructor(props) {
    super(props)
    let date = new Date()
    let day = parseInt(date.getDate())
    let month = months[date.getMonth()]
    let year = date.getFullYear()
    let haveDate = this.props?.location?.state?.currentDate
    let showDate = new Date()
    if (haveDate) {
      let dateArr = haveDate.split(' ')
      let newArr = []
      dateArr.map((e) => {
        if (e) {
          newArr.push(e)
        }
      })
      dateArr = newArr
      showDate = new Date(`${dateArr[0]}-${dateArr[1]}-${dateArr[2]}`)
    }
    console.log(this.props.location?.state)

    this.state = {
      inCompleteLoading: true,
      certData: {}
    }
    this.onChangeDate = this.onChangeDate.bind(this)
  }
  componentDidMount() {
    let date = new Date()
    let days = date.getDate()
    if (parseInt(days) < 10) {
      days = `0${days}`
    }
    let month = parseInt(date.getMonth()) + 1
    if (parseInt(month) < 10) {
      month = `0${month}`
    }
    let year = date.getFullYear()
    let saveDate = `${year}-${month}-${days}`
    let viewAllCheckWeightComplete = axios.post(
      'https://backend1.riceinspections.com/testGE',
      {
        data: {
          'timeValue': this.props.location?.state?.timeValue || saveDate
        }
      }
    )
    viewAllCheckWeightComplete.then((data) => {
      console.log(data.data)
      this.setState({
        ...this.state,
        inCompleteLoading: false,
        certData: data.data,
        startDate: new Date(this.props.location?.state?.timeValue)
      })
    })
  }
  exportSummeryCert = (dataIn, dayNo = 0) => {
    let XLSX = require('xlsx')
    let wb = XLSX.utils.book_new()
    let ws_name = "SheetJS"
    let ws_data = [['วันที่', 'ผู้ได้รับอนุญาต', 'ผู้ส่งมอบ', 'เลขที่ใบอนุญาต', 'คำสั่งจ่ายงานเลขที่', 'เรือใหญ่', 'เมืองตราส่ง'
      , 'ชนิดข้าว', 'ปริมาณ/เมตริกตัน', 'CER NO.', 'PAPER NO', 'PAPER NO', 'REMARK']]
    // let certDataArr = []
    Object.values(dataIn).map((data, idz) => {
      if (data) {
        Object.values(data).map((certData, idx) => {
          console.log(certData)
          // if (data['description'][idx] != null) {
          let certDataArr = []
          certDataArr.push(dayNo.getDate())
          certDataArr.push(certData['companyEN'])
          certDataArr.push(certData['godown'])
          certDataArr.push(certData['License'])
          certDataArr.push(certData['jobID'])
          certDataArr.push(certData['vehicleName'])
          certDataArr.push(certData['destinationCity'])
          certDataArr.push(certData['wtf1'])
          certDataArr.push(parseFloat(certData['TotalNett']))
          certDataArr.push(certData['No'])
          certDataArr.push(certData['pageNoStart'] || '')
          certDataArr.push(certData['pageNoStop'] || '')
          certDataArr.push('')
          ws_data.push(certDataArr)
          // }
        })
      }
    })
    // var ws = XLSX.utils.aoa_to_sheet(ws_data)
    // XLSX.utils.book_append_sheet(wb, ws, ws_name)
    // XLSX.writeFile(wb, `สรุปรายวัน.xlsx`)
  }

  exportSummeryCertByRangeDate = (startDate, endDate) => {
    let XLSX = require('xlsx')
    let wb = XLSX.utils.book_new()
    let ws_name = "SheetJS"
    let ws_data = [['วันที่', 'ผู้ได้รับอนุญาต', 'ผู้ส่งมอบ', 'เลขที่ใบอนุญาต', 'คำสั่งจ่ายงานเลขที่', 'เรือใหญ่', 'เมืองตราส่ง'
      , 'ชนิดข้าว', 'ปริมาณ/เมตริกตัน', 'CER NO.', 'PAPER NO', 'PAPER NO', 'REMARK']]

    function convertDate(inputDate) {
      let date = new Date(inputDate)
      let days = date.getDate()
      if (parseInt(days) < 10) {
        days = `0${days}`
      }
      let month = parseInt(date.getMonth()) + 1
      if (parseInt(month) < 10) {
        month = `0${month}`
      }
      let year = date.getFullYear()
      let outputDate = `${year}-${month}-${days}`
      return outputDate
    }
    function timeInterval(startDate, endDate) {
      var now = new Date(startDate);
      var then = new Date(endDate);
      var dayCount = 0;
      let dateArr = []
      dateArr.push(convertDate(startDate))
      while (now.setHours(1, 3, 3, 7) > then.setHours(1, 3, 3, 7)) {
        let newThen = then.setDate(then.getDate() + 1);
        dateArr.push(convertDate(newThen))
        dayCount++;
      }
      while (now.setHours(1, 3, 3, 7) < then.setHours(1, 3, 3, 7)) {
        let newNow = now.setDate(now.getDate() + 1);
        dateArr.push(convertDate(newNow))
        dayCount++;
      }
      var years = Math.floor(dayCount / 365);
      dayCount = dayCount - years * 365;
      var months = Math.floor(dayCount / 30);
      dayCount = dayCount - months * 30;
      var days = dayCount

      return dateArr
    }

    if(!endDate){
      endDate = startDate
    }
    let dateArr = timeInterval(convertDate(startDate), convertDate(endDate))
    let promiseNew = []
    dateArr = [...new Set(dateArr)]

    dateArr.map((dateSingle) => {
      let promiseGE = axios.post(
        'https://backend1.riceinspections.com/testGE',
        {
          data: {
            'timeValue': dateSingle
          }
        }
      ).then((res) => {
        return res['data']
      })
      promiseNew.push(promiseGE)
    })
    Promise.all(promiseNew).then((res) => {
      let newObj = []
      res.map((dataArr) => {
        dataArr.map((data) => {
          newObj.push(data)
        })
      })
      Object.values(newObj).map((data, idz) => {
        if (data) {
          Object.values(data).map((certData, idx) => {
            console.log(certData)
            if(certData['PackingType1']){
              let roundNumber = parseFloat(`${certData['TotalNett']}`.replaceAll(',',''))/1000

              console.log(addCommaInNumber(((Math.round((roundNumber + Number.EPSILON) * 100) / 100)).toFixed(2)))
              let certDataArr = []
              let vehicleNameIndex = parseInt(certData['vehicleName'].indexOf('“')) + 1
              certDataArr.push(certData['shippingDate'].split(' ')[0])
              certDataArr.push(certData['companyEN'].toUpperCase())
              certDataArr.push(certData['godown'].toUpperCase())
              certDataArr.push(certData['License'].slice(certData['License'].length-7 ,certData['License'].length))
              certDataArr.push(certData['jobID'])
              certDataArr.push(certData['vehicleName'].slice(vehicleNameIndex,certData['vehicleName'].length-1))
              certDataArr.push(certData['destinationCity'])
              certDataArr.push(certData['wtf1'])
              certDataArr.push(addCommaInNumber(((Math.round((roundNumber + Number.EPSILON) * 100) / 100)).toFixed(2)))
              certDataArr.push(certData['No'])
              certDataArr.push(certData['pageNoStart'] || '')
              certDataArr.push(certData['pageNoStop'] || '')
              certDataArr.push('')
              ws_data.push(certDataArr)
            }
            // }
          })
        }
      })
      var ws = XLSX.utils.aoa_to_sheet(ws_data)
      XLSX.utils.book_append_sheet(wb, ws, ws_name)
      XLSX.writeFile(wb, `สรุปรายวัน.xlsx`)
    })
  }
  onChangeDate = (dates) => {
    const [start, end] = dates
    this.setState({
      ...this.state,
      startDate: start,
      endDate: end
    })
  }
  render() {
    if (!this.state.inCompleteLoading) {
      return (
        <Container>
          <AdminNav></AdminNav>
          <div style={{ width: '100%', alignContent: 'center', textAlign: 'center', fontSize: '22px' }}  >
            <p><b>Quality and Weight Certificate ประจำวันที่ {this.props.location?.state?.timeValue}</b></p>
          </div>
          <DatePicker
            className='form-control'
            selected={this.state.startDate}
            onChange={this.onChangeDate}
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            selectsRange
            dateFormat="MMMM d, yyyy"
          ></DatePicker>
          <Button onClick={() => { this.exportSummeryCertByRangeDate(this.state.startDate, this.state.endDate) }}> ดาวน์โหลด </Button>
          <Table bordered hover style={{ tableLayout: 'fixed' }}>
            <thead>
              <tr>
                <th style={{ width: '3.7%', overflow: 'auto', fontSize: '11px' }}>Cert No.</th>
                <th style={{ width: '3.7%', overflow: 'auto', fontSize: '11px' }}>Paper No. (Origin)</th>
                <th style={{ width: '3.7%', overflow: 'auto', fontSize: '11px' }}>Paper No. (Copy)</th>
                <th style={{ width: '3.7%', overflow: 'auto', fontSize: '11px' }}>เลขทะเบียนงาน</th>
                <th style={{ width: '3.7%', overflow: 'auto', fontSize: '11px' }}>เลขที่ใบอนุญาต</th>
                <th style={{ width: '3.7%', overflow: 'auto', fontSize: '11px' }}>รายการที่</th>
                <th style={{ width: '3.7%', overflow: 'auto', fontSize: '11px' }}>ชื่อบริษัท</th>
                <th style={{ width: '3.7%', overflow: 'auto', fontSize: '11px' }}>สถานที่ส่งออก</th>
                <th style={{ width: '3.7%', overflow: 'auto', fontSize: '11px' }}>ชื่อพาหนะ</th>
                <th style={{ width: '3.7%', overflow: 'auto', fontSize: '11px' }}>ประเทศปลายทาง</th>
                <th style={{ width: '3.7%', overflow: 'auto', fontSize: '11px' }}>ชนิดข้าว</th>
                <th style={{ width: '3.7%', overflow: 'auto', fontSize: '11px' }}>ปริมาณ / ตัน</th>
              </tr>
            </thead>
            <tbody style={{ width: '100%' }}>
              {(() => {
                if (this.state.viewAllSurveyRequestSheetByDate) {
                  let indexForAll = 0
                  return Object.keys(this.state.viewAllSurveyRequestSheetByDate).map((dataName, idz) => {
                    // let c = this.state.viewAllSurveyRequestSheetByDate[data]
                    let data = this.state.viewAllSurveyRequestSheetByDate[dataName]
                    let certNo = this.state.certNoArr
                    // console.log(this.state.certNoArr)
                    if (data === 'requestCount') {
                      return null;
                    } else {
                      // console.log(data)
                      return (Object.values(data['description'])
                        // .sort((y,t)=>{
                        //   if(y['jobID'] && t['jobID']){
                        //     return  y['jobID'] < t['jobID'] ? -1 : y['jobID'] > t['jobID'] ? 1 : 0
                        //   }
                        // })
                        .map((output, idx) => {
                          let cert = []
                          // console.log(output)
                          // console.log(data['jobID'],output['licenseID'],output['subID'])
                          // console.log(certNo)
                          let No = null
                          let pageNoStop = null
                          let pageNoStart = null
                          // console.log(this.state.certNoArr[0])
                          if (certNo) {
                            let certTemp = certNo.filter((e) => {
                              // console.log(e)
                              if (e) {
                                let tranformE = e
                                return `${tranformE?.jobID}` == `${data?.jobID}` && `${tranformE.License}` == `${output?.licenseID}` && `${tranformE?.subID}` == `${output?.subID}`
                              }
                            })
                            if (certTemp.length > 0) {
                              cert = certTemp
                            }
                            // console.log(data?.jobID , output?.licenseID ,output?.subID )
                            // console.log(cert)
                            if (cert?.length > 0) {
                              No = cert[0]?.['No']
                              pageNoStop = cert[0]?.['pageNoStop']
                              pageNoStart = cert[0]?.['pageNoStart']
                            }
                          }
                          // console.log(certTemp.length)
                          let vehicleKey = ''
                          Object.keys(data['description'][idx]).map((key) => { if (key.indexOf('vehicleName') != -1) vehicleKey = key })
                          // console.log(No) 
                          if (this.renderDisplay(output, data['description'][idx]['licenseID'].slice(6, 13), data) != 'None') {
                            indexForAll += 1
                          }
                          // console.log(idz,Object.keys(this.state.viewAllSurveyRequestSheetByDate).length-1)
                          // console.log(indexForAll)
                          return (
                            <tr id={dataName} onClick={(e) => { this.handleTableClick(e, idx, data['jobID']) }} style={{ 'backgroundColor': output['isComplete'] == true ? '#90ee90' : 'white', 'display': this.renderDisplay(output, data['description'][idx]['licenseID'].slice(6, 13), data) }} >
                              <td ><input id={indexForAll} style={{ width: '100%', fontSize: '13px' }} onChange={(e) => { this.handleInputCertNo(e, data['jobID'], output.licenseID, output.subID) }} onKeyDown={(e) => { this.handlePressEnterCertNo(e) }} value={cert[0]?.['No'] || ''}></input></td>
                              <td ><input id={indexForAll} style={{ width: '100%', fontSize: '13px' }} onChange={(e) => { this.handleInputStartPageNo(e, data['jobID'], output.licenseID, output.subID) }} onKeyDown={(e) => { this.handlePressEnterStartCertNo(e) }} value={cert[0]?.['pageNoStart']}></input></td>
                              <td ><input id={indexForAll} style={{ width: '100%', fontSize: '13px' }} onChange={(e) => { this.handleInputStopPageNo(e, data['jobID'], output.licenseID, output.subID) }} onKeyDown={(e) => { this.handlePressEnterStopCertNo(e) }} value={cert[0]?.['pageNoStop']}></input></td>
                              <td style={{ fontSize: '13px' }}><b >{data['jobID']}</b></td>
                              <td style={{ fontSize: '13px' }}><b>{data['description'][idx]['licenseID'].slice(6, 13)}</b></td>
                              <td style={{ fontSize: '13px' }}><b>{parseInt(data['description'][idx]['subID']) + 1}</b></td>
                              <td style={{ overflow: 'auto', fontSize: '13px' }}><b >{data['companyID']}</b></td>
                              <td style={{ fontSize: '13px' }}><b>{data['surveyLocateName']} - {data['surveyProvince']}</b></td>
                              <td style={{ fontSize: '13px' }}><b>{data['description'][idx][vehicleKey]}</b></td>
                              <td style={{ fontSize: '13px' }}><b>{data['description'][idx]['destinationCity']}</b></td>
                              <td style={{ fontSize: '13px' }}><b>{data['description'][idx]['riceTypeName'] || convertRiceTypeENToTH(data['description'][idx]['riceTypeID'], this.state.riceTypeIDAndName, 'standalone')}</b></td>
                              <td style={{ fontSize: '13px' }}><b>{addCommaInNumber(this.renderQuantity(data, idx))}</b> <br /> </td>
                            </tr>
                          )
                        }))
                    }
                  }
                  )
                }
              })()
              }
            </tbody>
          </Table>
        </Container>
      )
    }
    else {
      return (<Container>
        <AdminNav></AdminNav>
        <Loading />
      </Container>)
    }
  }
}


export default withRouter(CertificateTable);
